import axios from 'axios'
import { getAnonymousId } from '@/utils/visitors'

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL

interface User {
  id: number
  name: string
  email: string
  is_admin?: boolean
  roles?: { name: string }[]
}

let cachedUser: User | null = null

async function getCurrentUser(token: string): Promise<User> {
  if (cachedUser !== null) {
    return cachedUser
  }

  const res = await axios.get(`${API_BASE_URL}/user`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    }
  })

  cachedUser = res.data as User

  return cachedUser
}


import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

import LawAssistantPage from "../pages/Apps/LawAssistantPage.vue";
import DecisionAnalysisPage from "../pages/Apps/DecisionAnalysisPage.vue";
import AiPrinciplesPage from "../pages/Apps/AiPrinciplesPage.vue";
import UsersListPage from "../pages/Users/UsersListPage.vue";
import AdminStatsPage from "../pages/Admin/AdminStatsPage.vue";
import AdminUserQuestionsPage from "../pages/Admin/AdminUserQuestionsPage.vue";
import ComparisonReportPage from "../pages/Admin/ComparisonReportPage.vue";
import ParserAdminPage from "../pages/Admin/ParserAdminPage.vue";
import SignInPage from "../pages/Authentication/SignInPage.vue";
import LockScreenPage from "../pages/Authentication/LockScreenPage.vue";
import LogoutPage from "../pages/Authentication/LogoutPage.vue";
import InternalErrorPage from "../pages/Error/InternalErrorPage.vue";
import NoAccessPage from "../pages/Error/NoAccessPage.vue";
import ErrorPage from "../pages/Error/ErrorPage.vue";
import MembersPage from "../pages/MembersPage.vue";
import AccountSettingsPage from "../pages/Settings/AccountSettingsPage.vue";
import ChangePasswordPage from "../pages/Settings/ChangePasswordPage.vue";
import ConnectionsPage from "../pages/Settings/ConnectionsPage.vue";


const routes: Array<RouteRecordRaw> = [

  {
    path: "/",
    redirect: "/authentication/sign-in",
  },

  {
    path: "/apps/decisions-ai",
    name: "LawAssistantPage",
    component: LawAssistantPage,
    meta: {
      title: "Yüksek Mahkeme Yapay Zeka Platformu",
      description: "Yasa ve Kararlar ile derlenmiş LLM Platformu.",
    },
  },

  {
    path: "/apps/ai-principles",
    name: "AiPrinciplesPage",
    component: AiPrinciplesPage,
    meta: {
      title: "Yapay Zeka Kullanım Kılavuzu – Mahai",
      description: "MahAI yapay zeka asistanını etkin kullanmak için kılavuz ve ipuçları.",
    },
  },

  {
    path: "/apps/decision-analysis",
    name: "DecisionAnalysisPage",
    component: DecisionAnalysisPage,
    meta: {
      title: "Karar Analizi - Mahai",
      description: "Mahkeme kararlarinizi yuksek mahkeme ictihatlariya karsilastirin.",
    },
  },

  {
    path: "/admin/users",
    name: "UsersListPage",
    component: UsersListPage,
    meta: {
      title: "Kullanıcılar – Yönetim – Mahai",
      description: "Mahai kullanıcılarını listeleyin, görüntüleyin ve yönetim işlemlerini gerçekleştirin.",
    },
  },

  {
    path: "/admin/users/:username/questions",
    name: "AdminUserQuestionsPage",
    component: AdminUserQuestionsPage,
    meta: { title: "Kullanıcı Soruları – Mahai" },
  },

  {
    path: "/admin/stats",
    name: "AdminStatsPage",
    component: AdminStatsPage,
    meta: {
      title: "Kullanım İstatistikleri - Mahai",
    },
  },

  {
    path: "/admin/comparison-report",
    name: "ComparisonReportPage",
    component: ComparisonReportPage,
    meta: {
      title: "Sistem Karşılaştırma Raporu - Mahai",
    },
  },

  {
    path: "/admin/parser",
    name: "ParserAdminPage",
    component: ParserAdminPage,
    meta: {
      title: "Parser Yönetimi - Mahai",
    },
  },

  {
    path: "/authentication/sign-in",
    name: "SignInPage",
    component: SignInPage,
    meta: {
      title: "Giriş Yap – Mahai",
      description: "Mahai hesabınıza giriş yapın.",
    },
  },
  {
    path: "/authentication/lock-screen",
    name: "LockScreenPage",
    component: LockScreenPage,
    meta: {
      title: "Ekran Kilidi – Mahai",
      description: "Hesabınızı korumak için oturumunuz kilitlendi. Devam etmek için tekrar doğrulayın.",
    },
  },
  {
    path: "/authentication/logout",
    name: "LogoutPage",
    component: LogoutPage,
    meta: {
      title: "Çıkış – Mahai",
      description: "Mahai oturumunuzu güvenle sonlandırın.",
    },
  },

  {
    path: "/errors/internal-error",
    name: "InternalErrorPage",
    component: InternalErrorPage,
    meta: {
      title: "Sunucu Hatası – Mahai",
      description: "Beklenmeyen bir hata oluştu. Lütfen daha sonra tekrar deneyin.",
    },
  },
  {
    path: "/errors/no-access",
    name: "NoAccess",
    component: NoAccessPage,
    meta: {
      title: "Erişim Yok – Mahai",
      description: "Bu sayfayı görüntüleme yetkiniz bulunmuyor.",
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "ErrorPage",
    component: ErrorPage,
    meta: {
      title: "Sayfa Bulunamadı – Mahai",
      description: "Aradığınız sayfa bulunamadı.",
    },
  },

  {
    path: "/members",
    name: "MembersPage",
    component: MembersPage,
    meta: {
      title: "Üyeler – Mahai",
      description: "Mahai üyelik ve hesap bilgilerinizi görüntüleyin.",
    },
  },

  {
    path: "/settings/account-settings",
    name: "AccountSettingsPage",
    component: AccountSettingsPage,
    meta: {
      title: "Hesap Ayarları – Mahai",
      description: "Mahai hesap ayarlarınızı yönetin.",
    },
  },

  {
    path: "/settings/change-password",
    name: "ChangePasswordPage",
    component: ChangePasswordPage,
    meta: {
      title: "Şifre Değiştir – Mahai",
      description: "Mahai hesap şifrenizi değiştirin.",
    },
  },

  {
    path: "/settings/connections",
    name: "ConnectionsPage",
    component: ConnectionsPage,
    meta: {
      title: "Bağlantılar – Mahai",
      description: "Mahai hesap bağlantılarınızı yönetin.",
    },
  },

];


const router = createRouter({
  history: createWebHistory(),
  routes,
  linkExactActiveClass: "active",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }

    if (to.hash) {
      const rawHash = to.hash.split('?')[0]

      try {
        const el = document.querySelector(rawHash)
        if (el) {
          return {
            el,
            behavior: 'smooth'
          }
        }
      } catch (e) {
        console.warn('scrollBehavior selector hatası:', to.hash, e)
      }
    }

    return { left: 0, top: 0 }
  },
});

router.beforeEach(async (to) => {
  const token = localStorage.getItem('auth_token')

  const publicPaths = new Set<string>([
    '/authentication/sign-in',
  ])

  const isPublic = publicPaths.has(to.path)

  if (isPublic) {
    if (token && to.path === '/authentication/sign-in') {
      return '/apps/decisions-ai'
    }
    return true
  }

  if (!token) {
    return {
      path: '/authentication/sign-in',
      query: { redirect: to.fullPath }
    }
  }

  const adminPaths = [
    '/admin/users',
    '/admin/stats',
    '/admin/comparison-report',
    '/admin/parser',
  ]

  const isAdminRoute = adminPaths.includes(to.path)

  if (isAdminRoute) {
    try {
      const user = await getCurrentUser(token)

      const isAdmin =
        user?.is_admin === true ||
        (Array.isArray(user?.roles) &&
          user.roles.some((r) => r.name === 'admin'))

      if (!isAdmin) {
        return '/errors/no-access'
      }
    } catch (e: any) {
      const status = e?.response?.status
      if (status === 401) {
        localStorage.removeItem('auth_token')
        return {
          path: '/authentication/sign-in',
          query: { reason: 'session_expired' }
        }
      }
      return {
        path: '/authentication/sign-in',
        query: { redirect: to.fullPath }
      }
    }
  }

  return true
})

router.afterEach((to, from) => {
  const titleBase = "Mahai";
  const pageTitle =
    (to.meta?.title as string) ||
    (typeof to.name === "string" ? `${to.name} – ${titleBase}` : titleBase);

  document.title = pageTitle;

  const setMeta = (name: string, content: string) => {
    let el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute("name", name);
      document.head.appendChild(el);
    }
    el.setAttribute("content", content);
  };

  const description =
    (to.meta?.description as string) ||
    "KKTC yasaları, tüzükleri ve mahkeme kararlarını yapay zeka ile arayın, analiz edin ve yorumlayın.";

  setMeta("description", description);

  const isAdminRoute =
    typeof to.path === "string" &&
    (to.path.startsWith("/admin") || to.path.startsWith("/dashboard"));

  const robots =
    (to.meta?.robots as string) || (isAdminRoute ? "noindex, nofollow" : "index, follow");

  setMeta("robots", robots);

  try {
    const params = new URLSearchParams(window.location.search);

    axios.post(
      `${process.env.VUE_APP_API_BASE_URL}/track/page-view`,
      {
        path: to.fullPath,
        page_name: to.name ?? null,
        referrer: document.referrer || null,
        utm_source: params.get("utm_source") || null,
        utm_medium: params.get("utm_medium") || null,
        utm_campaign: params.get("utm_campaign") || null,
      },
      {
        headers: { "X-Anonymous-Id": getAnonymousId() },
      }
    );
  } catch (e) {
    // tracking fail = ignore
  }
});



export default router;
